var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7415 7.32909C21.1121 7.73863 21.0805 8.37101 20.6709 8.74154L11.8288 16.7415C11.4508 17.0835 10.8761 17.0865 10.4946 16.7484L5.33673 12.177C4.92342 11.8106 4.88532 11.1786 5.25164 10.7653C5.61796 10.352 6.24998 10.3139 6.66329 10.6802L11.151 14.6577L19.3291 7.25847C19.7386 6.88794 20.371 6.91956 20.7415 7.32909Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.fb2397c6ac7d085b55a9237477e614fc.svg";
export { ForwardRef as ReactComponent };